import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../hooks/useAuth';

const MenuContext = createContext(null);

export const MenuProvider = ({ children }) => {
    const { isAuthenticated, user } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const cargar = useCallback(async () => {
        if (!isAuthenticated) {
            setItems([]);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await api.get('/me/menu');
            setItems(response.data?.items || []);
        } catch (e) {
            setError(e?.response?.data?.detail || 'Error al cargar el menú');
            setItems([]);
        } finally {
            setLoading(false);
        }
    }, [isAuthenticated]);

    useEffect(() => { cargar(); }, [cargar, user?.role]);

    const canAccess = useCallback(
        (menuKey) => items.some((it) => it.menu_key === menuKey),
        [items]
    );

    const canAccessPath = useCallback(
        (path) => items.some((it) => it.path && (path === it.path || path.startsWith(it.path + '/'))),
        [items]
    );

    // Omite encabezados de grupo (path vacío, solo expanden submenús) al elegir el destino por defecto.
    const firstPath = items.find((it) => it.path)?.path || '/login';

    return (
        <MenuContext.Provider value={{ items, loading, error, canAccess, canAccessPath, firstPath, reload: cargar }}>
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => {
    const ctx = useContext(MenuContext);
    if (!ctx) throw new Error('useMenu debe usarse dentro de MenuProvider');
    return ctx;
};
